export const fmt=n=>new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",maximumFractionDigits:0}).format(n);
export const fmtK=n=>n>=1000000?`$${(n/1000000).toFixed(1)}M`:n>=10000?`$${(n/1000).toFixed(0)}K`:fmt(n);